<template>
  <div class="container-fluid">
    <!-- <b-card class="mt-3 mb-1">
      <b-card-header class="p-0"
        ><b-card-body class="px-0 py-1">
          <b-card-title class="card-title-doorder my-1"
            >Orders List
          </b-card-title>
        </b-card-body>
      </b-card-header>
    </b-card> -->
    <b-tabs class="ordersTabsDoorder mt-3 mb-1" align="right">
      <b-tab
        title="Switch to list view"
        active
        title-link-class="btn btn-bumblebee btn-doorder btn-tab btn-doorder-primary"
      >
        <DoorderOrdersList />
      </b-tab>
      <b-tab
        v-if="user_title == 'admin'"
        lazy
        title="Switch to calendar view"
        title-link-class="btn btn-bumblebee btn-doorder btn-tab btn-doorder-primary"
      >
        <DoorderOrdersCalendar />
      </b-tab>

      <template #tabs-start>
        <li role="presentation" class="nav-item align-self-left">
          <b-card-title class="card-title-doorder my-1"
            >Orders List
          </b-card-title>
        </li>
        <li role="presentation" class="nav-item align-self-left"></li>
      </template>
    </b-tabs>
  </div>
</template>

<script>
import axios from "axios";
import DoorderOrdersList from "./TableView.vue";
import DoorderOrdersCalendar from "./CalendarView.vue";

export default {
  name: "DoOrderOrdersList",
  components: { DoorderOrdersList, DoorderOrdersCalendar },
  data() {
    return {
      client_name: "DOORDER",

      user_title: null,
    };
  },
  updated() {},
  watch: {},
  mounted() {
    console.log("in order list index mounted");

    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log(user);
    console.log(user.id, user.title);
    this.user_id = user.id;
    this.user_title = user.title;
    // this.getOrders(user.id);
    console.log(this.user_title);
  },
  methods: {},
};
</script>




// WEBPACK FOOTER //
// src/components/doorder/orders/lists/ListIndex.vue